import { Outside } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';

import React, { PureComponent } from 'react';

import { getPriceLabel, getPriceTitle } from '../../utils/price';

import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';

import * as styles from './FilterCoworkingPrice.css';
import { CoworkingPriceDropdown } from './internal/components/CoworkingPriceDropdown';
import { CoworkingPricePreview } from './internal/components/CoworkingPricePreview';
import { isValidInput } from './internal/helpers/isValidInput';
import { IFilterCoworkingPriceProps, IFilterCoworkingPriceState, NumberInputValue } from './types';

export class FilterCoworkingPrice extends PureComponent<IFilterCoworkingPriceProps, IFilterCoworkingPriceState> {
  public constructor(props: IFilterCoworkingPriceProps) {
    super(props);

    const { gte, lte } = props;

    this.state = {
      active: false,
      isErroneous: false,
      max: lte,
      min: gte,
    };
  }

  public componentWillUnmount(): void {
    const { onDestroy } = this.props;

    // eslint-disable-next-line no-unused-expressions
    onDestroy?.();
  }

  public render(): JSX.Element {
    const { active, min, max, isErroneous } = this.state;
    const { onPriceTypeChange } = this.props;

    return (
      <Outside active insideRefs={[]} onOutside={this.handleOutsideClick}>
        <div
          className={mergeStyles(stylesCommon['container'], styles['container']).className}
          data-mark="FilterCoworkingPrice"
        >
          <CoworkingPricePreview
            isActive={active}
            label={getPriceLabel(min, max)}
            onClick={this.handleButtonClick}
            title={getPriceTitle(min, max)}
          />
          {active && (
            <CoworkingPriceDropdown
              isErroneous={isErroneous}
              max={max}
              min={min}
              onMaxBlur={this.handleMaxBlur}
              onMaxValueChange={this.handleMaxValueChange}
              onMinBlur={this.handleMinBlur}
              onMinValueChange={this.handleMinValueChange}
              onPriceTypeChange={onPriceTypeChange}
            />
          )}
        </div>
      </Outside>
    );
  }

  private readonly handleButtonClick = (): void => {
    this.setState(state => ({ active: !state.active }));
  };

  private readonly handleOutsideClick = (): void => {
    this.setState({ active: false });
  };

  private readonly handleMinValueChange = (value: NumberInputValue): void => {
    this.setState(state => ({
      min: value,
      isErroneous: isValidInput(value, state.max),
    }));
  };

  private readonly handleMaxValueChange = (value: NumberInputValue): void => {
    this.setState(state => ({
      max: value,
      isErroneous: isValidInput(state.min, value),
    }));
  };

  private readonly handleMinBlur = (): void => {
    const { onMinPriceChange, gte } = this.props;
    const { min } = this.state;

    if (gte !== min) {
      onMinPriceChange(min);
    }
  };

  private readonly handleMaxBlur = (): void => {
    const { onMaxPriceChange, lte } = this.props;
    const { max } = this.state;

    if (lte !== max) {
      onMaxPriceChange(max);
    }
  };
}
